export default __webpack_public_path__ + "static/media/ug.a7d6ec6b.svg";